import React from 'react';

import { ScrollArea, Text } from '@mantine/core';
import { IconAdjustments } from '@tabler/icons-react';
import { CharacterCounter } from 'components/CharacterCounter';
import { OverviewCard } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/OverviewCard';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import { CUSTOM_PROMPT_MAX_LENGTH } from 'shared/utils/form-validators';

interface BehaviourOverviewProps {
  smartAssistant: SmartAssistant;
}

export function BehaviourOverview({ smartAssistant }: BehaviourOverviewProps) {
  const { t } = useTranslation();

  return (
    <OverviewCard title={t('SMART_ASSISTANT.OVERVIEW_SECTION.BEHAVIOR.TITLE')} icon={<IconAdjustments />}>
      <ScrollArea h="100%" offsetScrollbars>
        <Text size="sm">{smartAssistant.customSystemPrompt}</Text>
      </ScrollArea>
      <CharacterCounter
        align="right"
        mt={10}
        length={smartAssistant.customSystemPrompt.length}
        maxLength={CUSTOM_PROMPT_MAX_LENGTH}
      />
    </OverviewCard>
  );
}
